/** React */
import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import "moment/locale/es";

/** MUI icons */
import DeleteIcon from "@mui/icons-material/Delete";

/** MUI imports */
import {
    Checkbox,
    Grid,
    MenuItem,
    Typography,
} from "@mui/material";

/** Components */
import { addCases } from "../../redux/userSlice";
import BaseSelect2 from "../ui/BaseSelect2";
import casesService from "../../services/case";
import CustomDatePicker from "../ui/CustomDatePicker";
import FiltersPopover from "../ui/FiltersPopover";

const FiltersButtonAdmin = (props) => {
    const { mainUsers, devUsers, setShowSkeleton, setCases, subscriptionFilter, companyFilter, filters, setFilters, searchValue, setCasesOG } = props;

    const [t] = useTranslation("global");

    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [subsFilter, setSubsFilter] = React.useState(subscriptionFilter);
    const [comFilter, setComFilter] = React.useState(companyFilter);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    /* Filtraríamos por Banco (cuenta bancaria), fecha de carga (campo desde y hasta), formato, fecha de estados de cuenta (fecha desde y hasta), usuario y estatus.*/

    const attributes = [
        { id: 1, name: t("converter.status"), query: "id_status" },
        { id: 2, name: t("payment.concept"), query: "concept" },
        { id: 3, name: t("inbox.mainUser"), query: "case_responsible" },
        { id: 4, name: t("inbox.devUser"), query: "case_developer_manager" },
        { id: 5, name: t("inbox.testUser"), query: "case_test_manager" },
        { id: 6, name: t("inbox.priority"), query: "priority" },
        { id: 7, name: t("navBar.subscription"), query: "subscription" },
        { id: 8, name: t("dashboard.company"), query: "company" },
        { id: 9, name: t("inbox.creationDate"), query: "creation_date" },
        //{ id: 10, name: t("register.country"), query: "country" },
        //{ id: 12, name: t("credits.sortCases"), query: "sort" },
        //{ id: 11, name: t("converter.status"), query: "status" },
    ];

    const status = [
        { id: 1, name: t("inbox.analysis") },
        { id: 2, name: t("inbox.progress") },
        { id: 3, name: t("inbox.test") },
        { id: 4, name: t("inbox.solvedKiiper") },
        { id: 5, name: t("inbox.solvedUser") },
    ];

    const concept = [
        { id: 1, name: t("inbox.conversions") },
        { id: 2, name: t("inbox.newBank") },
        { id: 3, name: t("inbox.directRequest") },
    ];

    const priorities = [
        {
            name: t("inbox.urgent"),
            value: 1,
            color: "#FF007A",
        },
        {
            name: t("inbox.high"),
            value: 2,
            color: "#FFB23F",
        },
        {
            name: t("inbox.medium"),
            value: 3,
            color: "#3FA7D6",
        },
        {
            name: t("inbox.low"),
            value: 4,
            color: "#361A52",
        },
    ];

    const reloadAdmCases = async (params) => {
        setShowSkeleton(true);

        if (searchValue === "") {
            await casesService
                .getAdminCases(params)
                .then((data) => {
                    setCases(data);
                    setCasesOG(data);
                    dispatch(addCases(data.finalCount));
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            await casesService
            .getAdminCases(params)
            .then((data) => {
                const filterCases = {
                    ...data,
                    resolved: data.resolved.filter(
                        (item) =>
                            item.global_case_number?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.franchise_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.company_name?.toLowerCase().includes(searchValue.toLowerCase())
                    ),
                    pending: data.pending.filter(
                        (item) =>
                            item.global_case_number?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.franchise_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.company_name?.toLowerCase().includes(searchValue.toLowerCase())
                    ),
                    open: data.open.filter(
                        (item) =>
                            item.global_case_number?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.franchise_name?.toLowerCase().includes(searchValue.toLowerCase()) ||
                            item.company_name?.toLowerCase().includes(searchValue.toLowerCase())
                    ),
                };

                setCases(filterCases);
                setCasesOG(data);
                dispatch(addCases(data.finalCount));
            })
            .catch((err) => {
                console.log(err);
            });
        }

        setShowSkeleton(false);
    };

    const limit = 9;

    const addFilter = () => {
        let array = [...filters.filtersArray];

        if (array.length <= limit) {
            setFilters({
                ...filters,
                filtersArray: [
                    ...filters.filtersArray,
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                        multiple: [],
                    },
                ],
            });
        }
    };

    const removeFilter = async (index) => {
        let array = [...filters.filtersArray];

        if (index !== -1) {

            if (array[index].type === 7) {
                let index2 = array.map((item) => item.type).indexOf(8);
                if (index2 === -1) {
                    setSubsFilter(subscriptionFilter)
                    setComFilter(companyFilter)
                } else {
                    setComFilter(companyFilter)
                    let companyFind = companyFilter.filter((item) => array[index2].multiple.includes(item.company_id.toString())).map((item) => item.franchise_id.toString())
                    let filterSusc = subscriptionFilter.filter((item) => companyFind.includes(item.franchise_id.toString()))
                    setSubsFilter(filterSusc)
                }
            }

            if (array[index].type === 8) {
                let index2 = array.map((item) => item.type).indexOf(7);
                if (index2 === -1) {
                    setSubsFilter(subscriptionFilter)
                    setComFilter(companyFilter)
                } else {
                    setSubsFilter(subscriptionFilter)
                    let filterComp = companyFilter.filter((item) => array[index2].multiple.includes(item.franchise_id.toString()))
                    setComFilter(filterComp)
                }
            }

            array.splice(index, 1);
            setFilters({
                ...filters,
                filtersArray: array,
            });

            let objectFinal = {};

            array.forEach((item) => {
                const query = attributes.find((item2) => item2.id === item.type).query;
                if (item.value && item.type) {
                    objectFinal[query] = item.value
                }
                if (item.type && item.since !== "") {
                    objectFinal[query + "_since"] = item.since.format("YYYY-MM-DD")
                }
                if (item.type && item.until !== "") {
                    objectFinal[query + "_until"] = item.until.format("YYYY-MM-DD")
                }
                if (item.multiple && item.multiple.length > 0) {
                    objectFinal[query] = item.multiple;
                }
            });

            let params = {
                ...objectFinal,
            };

            await reloadAdmCases(params)
        }
    };

    const removeFirstFilter = async () => {
        setFilters({
            filtersArray: [
                {
                    type: "",
                    value: "",
                    since: "",
                    until: "",
                    multiple: [],
                },
            ],
        });

        await reloadAdmCases({})

        setSubsFilter(subscriptionFilter)
        setComFilter(companyFilter)
        //setCounFilter(countriesFilter)
    };

    const handleChangeType = (event, index) => {
        let aux = [...filters.filtersArray];
        aux[index].type = event.target.value;
        aux[index].value = "";
        aux[index].since = "";
        aux[index].until = "";
        aux[index].multiple = [];

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const handleChangeFilter = async (event, index, filterType) => {
        let aux = [...filters.filtersArray];

        if (filterType === 7 || filterType === 8 || filterType === 10 || filterType === 11) {
            aux[index].value = "";
            aux[index].since = "";
            aux[index].until = "";
            aux[index].multiple = event.target.value;
        } else if (filterType === 12) {
            aux[index].value = event.target.checked;
            aux[index].since = "";
            aux[index].until = "";
            aux[index].multiple = [];
        } else {
            aux[index].value = event.target.value;
            aux[index].since = "";
            aux[index].until = "";
            aux[index].multiple = [];
        }

        if (filterType === 7) { // Filtro de suscripcion, hay que filtrar las empresas
            let index2 = aux.map((item) => item.type).indexOf(8);
            if (index2 === -1 || aux[index2].multiple.length === 0) {
                let filterComp = companyFilter.filter((item) => event.target.value.includes(item.franchise_id.toString()))
                setComFilter(filterComp)
            } else {
                //Estaba primero el filtro de empresas
                if (index2 < index) {
                    setComFilter(companyFilter)
                    let companyFind = companyFilter.filter((item) => aux[index2].multiple.includes(item.company_id.toString())).map((item) => item.franchise_id)
                    let filterSusc = subscriptionFilter.filter((item) => companyFind.includes(item.franchise_id.toString()))
                    setSubsFilter(filterSusc)
                } else {
                    let filterComp = companyFilter.filter((item) => event.target.value.includes(item.franchise_id.toString()))
                    setComFilter(filterComp)
                }
            }
        }

        if (filterType === 8) { // Filtro de empresas, hay que filtrar las suscripciones
            let index2 = aux.map((item) => item.type).indexOf(7);
            if (index2 === -1 || aux[index2].multiple.length === 0) {
                let companyFind = companyFilter.filter((item) => event.target.value.includes(item.company_id.toString())).map((item) => item.franchise_id)
                let filterSusc = subscriptionFilter.filter((item) => companyFind.includes(item.franchise_id.toString()))
                setSubsFilter(filterSusc)
            } else {
                //Estaba primero el filtro de suscripciones
                if (index2 < index) {
                    setSubsFilter(subscriptionFilter)
                    let filterComp = companyFilter.filter((item) => aux[index2].multiple.includes(item.franchise_id.toString()))
                    setComFilter(filterComp)
                } else {
                    let companyFind = companyFilter.filter((item) => event.target.value.includes(item.company_id.toString())).map((item) => item.franchise_id)
                    let filterSusc = subscriptionFilter.filter((item) => companyFind.includes(item.franchise_id.toString()))
                    setSubsFilter(filterSusc)
                }
            }
        }

        let objectFinal = {};

        aux.forEach((item) => {
            const query = attributes.find((item2) => item2.id === item.type).query;
            if (item.value && item.type) {
                objectFinal[query] = item.value;
            }
            if (item.type && item.since !== "") {
                objectFinal[query + "_since"] = item.since.format("YYYY-MM-DD");
            }
            if (item.type && item.until !== "") {
                objectFinal[query + "_until"] = item.until.format("YYYY-MM-DD");
            }
            if (item.multiple && item.multiple.length > 0) {
                objectFinal[query] = item.multiple;
            }
        });

        let params = {
            ...objectFinal,
        };

        await reloadAdmCases(params)

        setFilters({
            ...filters,
            filtersArray: aux,
        });

    };

    const handleChangeFilterRange = async (event, index, filterType, range) => {
        let aux = [...filters.filtersArray];
        aux[index][range] = event;
        aux[index].value = "";

        let objectFinal = {};

        aux.forEach((item) => {
            const query = attributes.find((item2) => item2.id === item.type).query;
            if (item.value && item.type) {
                objectFinal[query] = item.value;
            }
            if (item.type && item.since) {
                objectFinal[query + "_since"] = item.since.format("YYYY-MM-DD");
            }
            if (item.type && item.until) {
                objectFinal[query + "_until"] = item.until.format("YYYY-MM-DD");
            }
            if (item.multiple && item.multiple.length > 0) {
                objectFinal[query] = item.multiple;
            }
        });

        let params = {
            ...objectFinal,
        };

        await reloadAdmCases(params)

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const cleanFilters = async (e) => {
        if (e.target.classList.contains("MuiAvatar-img")) {
            setFilters({
                filtersArray: [
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                        multiple: [],
                    },
                ],
            });


            await reloadAdmCases({})

            setSubsFilter(subscriptionFilter)
            setComFilter(companyFilter)

        }
    };

    return (
        <FiltersPopover
            id={id}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            cleanFilters={cleanFilters}
            handleClick={handleClick}
            length={filters.filtersArray.filter(
                (item) => item.type && (item.value || item.since || item.until || item.multiple.length > 0)
            ).length}
            addFilter={addFilter}
            disabled={filters.filtersArray.length === limit}
        >
            {filters.filtersArray.map((value, index) => (
                <Grid container spacing={2} alignItems="center" key={index} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={11}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                 <BaseSelect2
                                    size="small"
                                    value={value.type}
                                    onChange={(e) => handleChangeType(e, index)}
                                    label={t("filters.attribute")}
                                >
                                    {value.type !== "" ?
                                        attributes.filter(
                                            (item) => !filters.filtersArray
                                                .map((item) => item.type)
                                                .includes(item.id)
                                        )
                                        .concat(
                                            attributes.filter((item) => item.id === value.type)
                                        )
                                        .map((item) => (
                                            <MenuItem value={item.id} key={"attr_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))
                                    : attributes.filter(
                                        (item) => !filters.filtersArray
                                            .map((item) => item.type)
                                            .includes(item.id)
                                    )
                                    .map((item) => (
                                        <MenuItem value={item.id} key={"attr_" + item.id}>
                                            <Typography
                                                variant="body1"
                                                component="span"
                                                align="center"
                                                color="textPrimary"
                                                sx={{
                                                    fontStyle: "normal",
                                                }}
                                            >
                                                {item.name}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </BaseSelect2>
                            </Grid>
                            {value.type === "" && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        size="small"
                                        value={value.type}
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeType(e, index)}
                                        values={[]}
                                        disabled
                                    />
                                </Grid>
                            )}
                            {value.type === 1 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {status.map((item) => (
                                            <MenuItem value={item.id} key={"status_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 2 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {concept.map((item) => (
                                            <MenuItem value={item.id} key={"concept_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {(value.type === 3 || value.type === 5) && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {mainUsers.map((item) => (
                                            <MenuItem value={item.value} key={"mainUsers_" + item.value}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 4 && (
                                <Grid item xs={12} md={6}>
                                     <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {devUsers.map((item) => (
                                            <MenuItem value={item.value} key={"devUsers_" + item.value}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 6 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {priorities.map((item) => (
                                            <MenuItem value={item.value} key={"priorities_" + item.value}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 7 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        multiple
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        renderValue={(selected) => {
                                            return selected.map((item) => {
                                                return subscriptionFilter.filter((item2) => item2.franchise_id.toString() === item.toString())[0]
                                                    .franchise_name;
                                            })
                                            .join(", ");
                                        }}
                                        size="small"
                                        value={value.multiple}
                                    >
                                        {subsFilter.map((item) => (
                                            <MenuItem value={item.franchise_id} key={"franchise_id_" + item.franchise_id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    <Checkbox checked={value.multiple.includes(item.franchise_id)} />
                                                    {item.franchise_name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 8 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        multiple
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        renderValue={(selected) => {
                                            return selected.map((item) => {
                                                return companyFilter.filter((item2) => item2.company_id.toString() === item.toString())[0].company_name;
                                            })
                                            .join(", ");
                                        }}
                                        size="small"
                                        value={value.multiple}
                                    >
                                        {comFilter.map((item) => (
                                            <MenuItem value={item.company_id} key={"company_id_" + item.company_id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    <Checkbox checked={value.multiple.includes(item.company_id)} />
                                                    {item.company_name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {(value.type === 9) && (
                                <>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.since")}
                                            maxDate={
                                                filters.filtersArray[index]?.until
                                                    ? filters.filtersArray[index].until
                                                    : null
                                            }
                                            onChange={(e) => handleChangeFilterRange(e, index, value.type, "since")}
                                            value={value.since ? value.since : null}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.until")}
                                            minDate={
                                                filters.filtersArray[index]?.since
                                                    ? filters.filtersArray[index].since
                                                    : null
                                            }
                                            onChange={(e) => handleChangeFilterRange(e, index, value.type, "until")}
                                            value={value.until ? value.until : null}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={1} display="flex" justifyContent="center">
                        {filters.filtersArray.length > 1 && (
                            <DeleteIcon
                                color="primary"
                                sx={{ cursor: "pointer" }}
                                onClick={() => removeFilter(index)}
                            />
                        )}
                        {filters.filtersArray.length === 1 &&
                            (value.value !== "" || value.since !== "" || value.until !== "" || value.multiple.length > 0) && (
                                <DeleteIcon
                                    color="primary"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => removeFirstFilter()}
                                />
                            )}
                    </Grid>
                </Grid>
            ))}
        </FiltersPopover>
    );
};

export default FiltersButtonAdmin;
